var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Badge } from "../../generic/badge/Badge";
import { ButtonInfoSmall } from "../../generic/common/ButtonInfoSmall";
import { IconBuilding } from "../../generic/common/icon-building/IconBuilding";
import { IdIconBuildingContext } from "../../generic/common/icon-building/IdIconBuildingContext";
import { ImageBoxContainer } from "../../generic/common/ImageBoxContainer";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLoca } from "../../generic/text/TextLoca";
var BuildingInformation = /** @class */ (function (_super) {
    __extends(BuildingInformation, _super);
    function BuildingInformation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBuildingSize = function () {
            var item = _this.props.item;
            return (React.createElement("div", { className: "building-detail__information-size" },
                React.createElement(Icon, { icon: IdIcon.GridIcn, styleId: IdStyles.IconSmall }),
                React.createElement("div", { className: IdStyles.TextBoldAccent },
                    item.xExtent,
                    "X",
                    item.yExtent)));
        };
        _this.getInfoButton = function () {
            var onInfoButton = _this.props.onInfoButton;
            return (React.createElement(Badge, null,
                React.createElement(ButtonInfoSmall, { onClick: onInfoButton },
                    React.createElement(Icon, { icon: IdIcon.InfoIcn, styleId: IdStyles.IconSmall }))));
        };
        return _this;
    }
    BuildingInformation.prototype.render = function () {
        var _a = this.props, item = _a.item, children = _a.children;
        var buildingSize = this.getBuildingSize();
        var buildingInfoButton = this.getInfoButton();
        var isBuildingSpecial = item.backgroundColor;
        var itemStage = item.stage[(item.stageId || 1) - 1 || 0];
        var level = itemStage.visualLevel || itemStage.level || 1;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: IdStyles.TextButtonHeading },
                React.createElement(TextLoca, { id: item.locaKey })),
            React.createElement("div", { className: "building-detail__information" },
                React.createElement("div", { className: "building-detail__information-image" },
                    React.createElement(ImageBoxContainer, { className: isBuildingSpecial
                            ? IdStyles.ImageBoxContainerPremiumSmall
                            : IdStyles.ImageBoxContainerSmall },
                        React.createElement(IconBuilding, { level: level, buildingName: item.name, context: IdIconBuildingContext.BuildDetail }),
                        buildingSize,
                        buildingInfoButton)),
                children)));
    };
    return BuildingInformation;
}(React.Component));
export { BuildingInformation };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/BuildingInformation.tsx
// module id = 935
// module chunks = 3